import React from "react";

export function KpiCard({ label, value, hint, testId }) {
    return (
        <div
            className="rounded-2xl border border-klareet-bor bg-klareet-card p-5 md:p-6"
            data-testid={testId}
        >
            <div className="text-[11px] uppercase tracking-[0.18em] font-mono text-klareet-MUT">
                {label}
            </div>
            <div className="mt-3 font-mono font-semibold tabular-nums text-3xl md:text-4xl text-klareet-TEXT">
                {value}
            </div>
            {hint ? (
                <div className="mt-2 text-xs text-klareet-DIM font-mono">
                    {hint}
                </div>
            ) : null}
        </div>
    );
}
